import { apiGetCategorySelect } from '@/actions/CategoryActions';
import { useDidMount } from '@/hooks/lifecycle/useDidMount';
import UserPreviewState from '../../user/UserPreviewState';
import { useClientSeminarListSearch } from './useClientSeminarListSearch';
/**
 * セミナー一覧の表示ロジックの実装
 * @param options
 * @returns {{onChangeTypeFilter: *, onClickCategory: *, images: *, onClickDocument: *, isShowDocumentModal: *, onLoadMoreSeminars: *, paging: *, loading: *, hideDocumentModal: *}}
 */
export const useClientSeminarList = (options) => {
    const { dispatch, locationState, unmountRef } = options;
    // セミナーの検索処理
    const locationStateKey = 'seminarData';
    const { getReplaceUrl, hideDocumentModal, images, isShowDocumentModal, loadSeminars, loading, onChangeDocumentImage, onChangeTypeFilter, onClickCategory, onClickDocument, onClickSearchResult, onLoadMoreSeminars, paging, } = useClientSeminarListSearch({ dispatch, locationStateKey, unmountRef });
    useDidMount(() => {
        // セミナーカテゴリーの取得
        dispatch(apiGetCategorySelect('seminar_category'));
        // history.stateに初期値がない、もしくはプレビュー表示時はデータを再取得する
        const stateData = (locationState || {})[locationStateKey];
        if (!stateData || UserPreviewState.isPreview) {
            // セミナーの読み込み
            const { param, url } = getReplaceUrl(null);
            loadSeminars(url, param).then();
        }
    });
    return {
        hideDocumentModal,
        images,
        isShowDocumentModal,
        loading,
        onChangeDocumentImage,
        onChangeTypeFilter,
        onClickCategory,
        onClickDocument,
        onClickSearchResult,
        onLoadMoreSeminars,
        paging,
    };
};
